import User from './user.js';
import Edit from './edit.js';
import Trash from './trash.js';
import SwitchPlan from './switchPlan.js';
import PaymentMethod from './paymentMethod.js';
import Close from './close.js';
import Back from './back.js';
import Keep from './keep.js';
import Gift from './gift.js';
import Eye from './eye.js';
import EyeCrossed from './eyeCrossed.js';
import Down from './down.js';
import Up from './up.js';
import Bank from './bank.js';
import AddPayment from './addPayment.js';

var CustomizableIcons = {
  User: User,
  Edit: Edit,
  Trash: Trash,
  SwitchPlan: SwitchPlan,
  PaymentMethod: PaymentMethod,
  Close: Close,
  Back: Back,
  Keep: Keep,
  Gift: Gift,
  Eye: Eye,
  EyeCrossed: EyeCrossed,
  Down: Down,
  Up: Up,
  Bank: Bank,
  AddPayment: AddPayment
};

export { CustomizableIcons as default };
//# sourceMappingURL=index.js.map
